import React from "react";
import { formatDate } from "../../../utils/dateFormatter";

const DeliveryChargesTab = ({ data, onDelete }) => {
  return (
    <>

    <div className="space-y-4 montserrat-font-1">
      {data?.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="bg-white border rounded-xl p-6 shadow-sm montserrat-font-1">
            
            <div className="flex justify-between mb-4">
              <h2 className="text-green-600 font-semibold">
                Currently Applied Delivery Charges
              </h2>

              {/* <button
                onClick={() => onDelete(item.id)}
                className="bg-red-500 text-white px-3 py-1 rounded-md text-xs"
              >
                Remove
              </button> */}
            </div>

            <div className="border-t pt-4 space-y-2 text-sm montserrat-font-1">
              <div className="flex justify-between">
                <span>Delivery Charges:</span>
                <span>
                  ₹{parseFloat(item.delivery_charges || 0).toFixed(2)}
                </span>
              </div>

              <div className="flex justify-between montserrat-font-1">
                <span>Status:</span>
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    item.status === "Y"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {item.status === "Y" ? "Active" : "Inactive"}
                </span>
              </div>

              <div className="flex justify-between montserrat-font-1">
                <span>Date:</span>
                <span>{formatDate(item.indate)}</span>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center text-gray-500">
          No delivery charges found
        </div>
      )}
    </div>
    </>
  );
};

export default DeliveryChargesTab;